import React, { useCallback, useState } from 'react';
import { MapPin } from 'lucide-react';
import { useLocale } from '../context/LocaleContext';

const PathTimelineItem = ({
  icon: Icon,
  title,
  subtitle,
  period,
  location,
  details = [],
  variant = 'education',
}) => {
  const { t } = useLocale();
  const [flipped, setFlipped] = useState(false);
  const hasDetails = details.length > 0;

  const toggleFlip = useCallback(() => {
    if (!hasDetails) return;
    if (typeof window !== 'undefined' && window.matchMedia('(hover: none)').matches) {
      setFlipped((current) => !current);
    }
  }, [hasDetails]);

  const handleKeyDown = useCallback(
    (event) => {
      if (!hasDetails) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleFlip();
      }
    },
    [hasDetails, toggleFlip],
  );

  return (
    <li className="path-timeline__item" data-reveal="left">
      <div className="path-timeline__rail" aria-hidden="true">
        <span className={`path-timeline__node path-timeline__node--${variant}`}>
          <Icon size={15} strokeWidth={2} />
        </span>
      </div>

      <article
        className={`path-flip-card path-flip-card--${variant}${flipped ? ' is-flipped' : ''}${
          hasDetails ? '' : ' path-flip-card--static'
        }`}
        onClick={toggleFlip}
        onKeyDown={handleKeyDown}
        tabIndex={hasDetails ? 0 : -1}
        role={hasDetails ? 'button' : undefined}
        aria-expanded={hasDetails ? flipped : undefined}
        aria-label={hasDetails ? `${title} — ${t('skills_flip_hint')}` : undefined}
      >
        <div className="path-flip-card__inner">
          <div className="path-flip-card__face path-flip-card__face--front">
            <header className="path-flip-card__head">
              <h4 className="path-flip-card__title">{title}</h4>
              {period ? <time className="path-flip-card__period">{period}</time> : null}
            </header>

            {subtitle ? <p className="path-flip-card__subtitle">{subtitle}</p> : null}

            {location ? (
              <p className="path-flip-card__location">
                <MapPin size={13} aria-hidden="true" />
                {location}
              </p>
            ) : null}

            {hasDetails ? (
              <p className="path-flip-card__hint">
                <span className="path-flip-card__hint-desktop">{t('skills_flip_hint')}</span>
                <span className="path-flip-card__hint-touch">{t('skills_flip_hint_touch')}</span>
              </p>
            ) : null}
          </div>

          {hasDetails ? (
            <div className="path-flip-card__face path-flip-card__face--back">
              <header className="path-flip-card__back-head">
                <h4 className="path-flip-card__back-title">{title}</h4>
                {period ? <time className="path-flip-card__back-period">{period}</time> : null}
              </header>

              <ul className="path-flip-card__details">
                {details.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      </article>
    </li>
  );
};

export default PathTimelineItem;
